import React from "react";
import { sanitize } from "@/framework/utils/sanitize";
import Facebook from "@/components/ui/icons/facebook";
import Pinterest from "@/components/ui/icons/pinterest";
import Linkedin from "@/components/ui/icons/linkedin";
import Whatsapp from "@/components/ui/icons/whatsapp";
import Youtube from "@/components/ui/icons/youtube";
import Instagram from "@/components/ui/icons/instagram";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "next-share";
export default function Social({ blog }) {
  const iconClass =
    "text-beige hover:text-darkGrey transition-all duration-300 ease";
  return (
    <div className="flex flex-col md:px-8 px-4 w-full mx-auto gap-3 items-start justify-end mb-16 max-w-[1080px]">
      <div className="flex flex-row flex-wrap w-full max-w-[268px] gap-3">
        {blog?.blog_tags?.data
          ?.map((row) => sanitize(row))
          ?.map((tag, key) => {
            return <Tag key={key}>{tag.name}</Tag>;
          })}
      </div>
      <div className="flex items-center gap-4">
        <FacebookShareButton
          url={`https://www.chalkstudio.design/blog-${blog?.slug}`}
          quote={blog?.excerpt}
          hashtag={`#${blog?.slug}`}
        >
          <Facebook className={iconClass} />
        </FacebookShareButton>
        <LinkedinShareButton
          url={`https://www.chalkstudio.design/blog-${blog?.slug}`}
        >
          <Linkedin className={iconClass} />
        </LinkedinShareButton>
        <TwitterShareButton
          url={`https://www.chalkstudio.design/blog-${blog?.slug}`}
          title={blog?.title}
        >
          <Linkedin className={iconClass} />
        </TwitterShareButton>
        <WhatsappShareButton
          url={`https://www.chalkstudio.design/blog-${blog?.slug}`}
          title={blog?.title}
          separator=":: "
        >
          <Whatsapp className={iconClass} />
        </WhatsappShareButton>
        <a
          href="#"
          target="_blank"
          rel="noreferrer"
          className={iconClass}
          aria-label="Instagram Button"
        >
          <Instagram />
        </a>
      </div>
    </div>
  );
}
const Tag = ({ children }) => {
  return (
    <div className="bg-[#E9E7DE] px-2 py-3 text-center text-darkGrey/70 text-[12px]">
      {children}
    </div>
  );
};
